import { render, staticRenderFns } from "./signProcess.vue?vue&type=template&id=66483533&scoped=true&"
import script from "./signProcess.vue?vue&type=script&lang=js&"
export * from "./signProcess.vue?vue&type=script&lang=js&"
import style0 from "./signProcess.vue?vue&type=style&index=0&id=66483533&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66483533",
  null
  
)

export default component.exports